import Axios from '@/axios';

// 创建审核节点
export const createExamineNodeConfig = data => {
  return Axios({
    url: '/face/web/examine/create_examine_node_config',
    method: 'POST',
    type: 'json',
    data
  })
}
// 删除审核节点
export const deleteExamineNodeConfig = id => {
  return Axios({
    url: `/face/web/examine/delete_examine_node_config/${id}`,
    method: 'POST',
    type: 'json'
  })
}

// 查询所有审核节点详情
export const listExamineNodeConfig = () => {
  return Axios({
    url: '/face/web/examine/list_examine_node_config',
    method: 'POST',
    type: 'json'
  })
}

// 查询审核配置
export const showExamineConfig = () => {
  return Axios({
    url: '/face/web/examine/show_examine_config',
    method: 'POST',
    type: 'json'
  })
}

// 修改审核节点
export const updateExamineNodeConfig = (id,data) => {
  return Axios({
    url: `/face/web/examine/update_examine_node_config/${id}`,
    method: 'POST',
    type: 'json',
    data
  })
}

// 修改审核节点顺序
export const updateExamineNodeConfigOrder = data => {
  return Axios({
    url: '/face/web/examine/update_examine_node_config_order',
    method: 'POST',
    type: 'json',
    data
  })
}
